module.exports = __webpack_public_path__ + "assets/img/QC.2c42ffaa.svg";